import React from 'react'
import { Stack, Box, Skeleton } from '@mui/material'

const TrafficDistributionWidgetSkeleton = () => {
  return (
    <Box
      sx={{
        width: { xs: '100%', sm: '50%', md: '25%' },
        border: '1px solid #EFEFEF',
        borderRadius: '16px',
        padding: 2,
        backgroundColor: '#FFFFFF',
        minHeight: '100px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <Stack spacing={0.5} alignItems="center" sx={{ width: '100%' }}>
        <Skeleton variant="circular" width={16} height={16} />
        <Skeleton variant="text" width={120} height={14} />
        <Skeleton variant="rectangular" width="100%" height={16} sx={{ mt: 2, borderRadius: '6px' }} />
        <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
          <Skeleton variant="text" width={60} height={10} />
          <Skeleton variant="text" width={60} height={10} />
          <Skeleton variant="text" width={60} height={10} />
        </Stack>
      </Stack>
    </Box>
  )
}

export default TrafficDistributionWidgetSkeleton